// removed by extract-text-webpack-plugin
module.exports = {"component":"_3N9KUzu9pgwNvVaR4rNnKU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AcceptTerms/acceptTerms.css
// module id = 1092
// module chunks = 2